import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import ButtonContent from './ButtonContent';
import ButtonBase from './ButtonBase';
const ButtonBaseWithContent = /*#__PURE__*/React.forwardRef(({
  as,
  forwardedAs,
  noIconWrapper = false,
  noChildren = false,
  icon,
  iconRight,
  iconMargin,
  iconRightMargin,
  iconSize,
  iconRightSize,
  iconTopPosition,
  iconRightTopPosition,
  title,
  subTitle,
  size = 'medium',
  vertical = false,
  children,
  ...props
}, forwardedRef) => /*#__PURE__*/React.createElement(ButtonBase, _extends({
  vertical: vertical,
  ref: forwardedRef,
  forwardedAs: as ?? forwardedAs
}, props), /*#__PURE__*/React.createElement(ButtonContent, {
  noIconWrapper: noIconWrapper,
  noChildren: noChildren,
  icon: icon,
  iconRight: iconRight,
  iconMargin: iconMargin,
  iconRightMargin: iconRightMargin,
  iconSize: iconSize,
  iconRightSize: iconRightSize,
  iconTopPosition: iconTopPosition,
  iconRightTopPosition: iconRightTopPosition,
  title: title,
  subTitle: subTitle,
  size: size,
  vertical: vertical,
  content: children
})));
export default ButtonBaseWithContent;